import React from 'react'; // eslint-disable-line
import { createRoot } from 'react-dom/client';
import ErrorBoundary from '../ErrorBoundary';

import DialogRadios from './views/index'; // eslint-disable-line

export default function (params) {
  const parentEl = params.parentEl || document.querySelector('.wrapperRadiosDialog');
  const {
    title, onOk, okName, cancelName, onCancel, onClose, checkbox, items, helpLink, description, text, bottomHelpLinkUrl, bottomHelpLinkTitle,
  } = params;
  const root = createRoot(parentEl);

  const close = () => {
    parentEl && root.unmount();
    onClose && onClose();
  };
  const cancel = () => {
    onCancel && onCancel();
    close();
  };
  const ok = (value, checkbox) => {
    onOk && onOk(value, checkbox);
    close();
  };

  root.render(
    <ErrorBoundary>
      <DialogRadios
        title={title}
        onClose={close}
        onCancel={cancel}
        onOk={ok}
        textBtnOk={okName}
        textBtnCancel={cancelName}
        items={items}
        checkbox={checkbox}
        helpLink={helpLink}
        description={description}
        text={text}
        bottomHelpLinkUrl={bottomHelpLinkUrl}
        bottomHelpLinkTitle={bottomHelpLinkTitle}
      />
    </ErrorBoundary>,
  );

  const API = {};

  return API;
}
